import { render, staticRenderFns } from "./LoginBvs.vue?vue&type=template&id=1c36d8d7"
import script from "./LoginBvs.vue?vue&type=script&lang=js"
export * from "./LoginBvs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports